// extracted by mini-css-extract-plugin
export var container = "_ux-0";
export var table = "_ux-2";
export var tableWrapper = "_ux-1";